const doc = [({"en":({"js":({"roles":({"select":({"choose_role":"Choose role"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;